export const formatMoney = (n) =>
  n || n === 0 ? n.toLocaleString("es-AR", { minimumFractionDigits: 2 }) : "-";
